import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { HelpOptionsList } from './help-options-list.model';

@Injectable()
export class HelpOptionsListService {

  constructor(private http: HttpClient) { }

}
